import * as React from 'react';

export interface EmptyStateProps {
  theme?: EmptyStateTheme;
  title?: string | React.ReactNode;
  subtitle?: string | React.ReactNode;
  image?: string | React.JSX.Element;
  children?: React.ReactNode;
  classNames?: { imageContainer?: string };
  dataHook?: string;
  align?: EmptyStateAlign;
  className?: string;
}

export declare const defaultEmptyStateProps: EmptyStateProps;

export declare const EmptyState: React.FC<EmptyStateProps>;
export default EmptyState;
export type EmptyStateTheme = 'page' | 'page-no-border' | 'section';
export type EmptyStateAlign = 'start' | 'center' | 'end';
